import React from "react";
import { Outlet } from "react-router-dom";
import GlobalPayrollTabs from "./GlobalPayrollTabs";

const GlobalPayroll = () => {
  return (
    <div className="container-fluid">
      <GlobalPayrollTabs />

      <div className="mt-3">
        <Outlet />
      </div>
    </div>
  );
};

export default GlobalPayroll;
